module.exports = __webpack_public_path__ + "img/icon-reading.d6c9c377.gif";